import DropdownMenu from '@/components/DropdownMenu';
import { TruncatedText } from 'components/TruncatedText';
import PluginIcon from 'pages/scope/PluginIcon';
import { useAvailableDataStreamDefinitionsForWorkspace } from 'queries/hooks/useAvailableDataStreamDefinitionsForWorkspace';
import { useSplashScreenDataStreamSelect } from '../hooks/useSplashScreenDataStreamSelect';
import { TileEditorDataStreams } from '../state/useTileEditorDataStreams';

interface SplashScreenOptionsDropdownOptionProps {
    id: string;
    name: string;
    dataStreams: NonNullable<ReturnType<typeof useAvailableDataStreamDefinitionsForWorkspace>['data']>;
    tileEditorDataStreams: TileEditorDataStreams;
}

export const SplashScreenOptionsDropdownOption: React.FC<SplashScreenOptionsDropdownOptionProps> = ({ 
    id,
    name, 
    dataStreams, 
    tileEditorDataStreams 
}) => {
    const { selectDatasource } = useSplashScreenDataStreamSelect(id, dataStreams, tileEditorDataStreams);

    return (
        <DropdownMenu.Item 
            key={id}
            onSelect={() => selectDatasource()}
            icon={<PluginIcon     
                pluginName={name} 
                className='w-7 h-7'
            />}
            className='text-nowrap'      
        >
            <span className='flex gap-3'>
                <TruncatedText 
                    title={name} 
                    className='items-center min-w-0'
                />
            </span>
        </DropdownMenu.Item>
    );
};
